import { FluxType } from 'flux/buildFlux';
import { AppServices } from 'services/Service';
import Logger from 'utils/Logger';

import { Services } from './services';

export default function CordovaServices(flux: FluxType): AppServices {
  Logger.log('deviceready');

  const services = new Services(flux);
  return services.build();
}
